define('components/asset-player/views/assets/video',[
    'components/asset-player/models/media-file',
    'components/asset-player/radio-channel'
], function (MediaFile, channel) {
    "use strict";

    return Mn.ItemView.extend({
        "render": function () {
            this.$el.each(_.bind(function (idx, elem) {
                var $elem = $(elem);

                this.embedVideo($elem);

                $elem.trigger('asset:render');
            }, this));
        },

        "getMediaFileUrl": function ($elem) {
            var typeId = $elem.data('type-id') || null,
                typeIds,
                mediaFiles,
                mediaFileUrl;

            typeIds = typeId && [typeId] || [
                MediaFile.Type['2MB_MP4'],
                MediaFile.Type['300K_MP4']
            ];

            mediaFiles = this.model.get('mediaFiles').filter(_.bind(function (mediaFile) {
                return mediaFile.get('url') && typeIds.indexOf(mediaFile.get('typeId')) > -1;
            }, this));

            mediaFileUrl = mediaFiles.length && mediaFiles[0].get('url') || '';

            return mediaFileUrl;
        },

        "adjustCaptionsUrl": function (url, id) {
            var captionUrl = url,
                currentDomain = ".discoveryeducation.com",
                updatedDomain = ".discoveryed.net";

            if (!captionUrl.length || captionUrl.indexOf(currentDomain) < 0){
                return captionUrl;
            }

            captionUrl = captionUrl.replace(currentDomain,updatedDomain);
            captionUrl = captionUrl.substring(0, captionUrl.indexOf(updatedDomain) + updatedDomain.length);
            captionUrl += "/vtt/" + id;

            return captionUrl;
        },

        "getWebVTTUrl": function ($elem) {
            var webVTTMediaFile,
                mediaFileUrl;

            webVTTMediaFile = this.model.get('mediaFiles').findWhere({
                "typeId": MediaFile.Type.WEB_VTT
            });

            mediaFileUrl = webVTTMediaFile && webVTTMediaFile.get('url') || '';
            mediaFileUrl = this.adjustCaptionsUrl(mediaFileUrl,this.model.get("guid"));
            
            return mediaFileUrl;
        },

        "embedVideo": function ($elem) {
            var $video,
                autoplay = $elem.data('autoplay') || '',
                mediaFileUrl = this.getMediaFileUrl($elem),
                webVTT = this.getWebVTTUrl($elem),
                isMuted,
                isCCed;

            isCCed = channel.request(channel.Event.Transcript.GET);
            isMuted = channel.request(channel.Event.Mute.GET);

            autoplay = autoplay.toString().toLowerCase().trim();

            $video = $('<video preload="none" crossorigin="anonymous" />');

            if (autoplay === 'true' || autoplay === '1') {
                $video.attr('autoplay', '');
            }

            if (isMuted) {
                $video.attr('muted', '')
                      .prop('muted', true);
            }

            $('<source />').attr('src', mediaFileUrl)
                           .appendTo($video);

            if (webVTT) {
                $('<track kind="captions" srclang="en" />')
                    .attr('src', webVTT)
                    .appendTo($video);
                if (isCCed) {
                    $video.prop('textTracks')[0].mode = 'showing';
                } 
            }

            $elem.html($video);
        }
    });
});

